import React, { useState, useEffect } from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import ReactConfetti from 'react-confetti';

const InterviewComplete: React.FC = () => {
  const [windowDimension, setWindowDimension] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const detectSize = () => {
      setWindowDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', detectSize);

    // Stop confetti after 5 seconds
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => {
      window.removeEventListener('resize', detectSize);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center p-4">
      {showConfetti && (
        <ReactConfetti
          width={windowDimension.width}
          height={windowDimension.height}
          recycle={true}
          numberOfPieces={200}
          gravity={0.2}
          colors={['#4F46E5', '#60A5FA', '#34D399', '#F59E0B', '#EC4899']}
        />
      )}
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full mx-auto text-center">
        <div className="mb-6">
          <CheckCircleOutlined className="text-6xl text-green-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Thank You for Your Time!
        </h1>
        
        <p className="text-lg text-gray-600 mb-4">
          Your feedback has been successfully recorded. We greatly appreciate your insights and thoughtful responses.
        </p>

        <p className="text-gray-500">
          You can now close this window.
        </p>
      </div>
    </div>
  );
};

export default InterviewComplete; 